import store from '@/store';
import {QuantityTableInfo} from "@/services/quantityTables/entities/QuantityTableInfo";
import {ClientTableInfo} from "@/services/clients/entities/ClientTableInfo";

export const snackCalculator = (BMI: number): number[] => {
    let recommendedSnacks: number[] = [0, 0];
    if (BMI >= 40 ) {
        recommendedSnacks = [150, 150];
    } else if (BMI >= 35 && BMI < 40) {
        recommendedSnacks = [100, 100];
    } else if (BMI >= 33 && BMI < 35) {
        recommendedSnacks = [100, 50];
    } else if (BMI >= 30 && BMI < 33) {
        recommendedSnacks = [50, 50];
    } else if (BMI >= 25 && BMI < 30) {
        recommendedSnacks = [50, 50];
    } else if (BMI >= 18.5 && BMI < 25) {
        recommendedSnacks = [50, 0];
    }
    return recommendedSnacks;
}

export const formatDateToISO = (date: Date): string => {
    return date.toISOString().split('T')[0];
}

export const formatDateTimeToDisplay = (date: Date): string => {
    if (!date) return "Sin cita";
    return new Date(date).toLocaleString('es-MX', {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
}

export const BMILevel = (BMI: number): string => {
    let levelMessage: string = "Desconocido";
    if (BMI >= 40) {
        levelMessage = "Obesidad grado III";
    } else if (BMI >= 35) {
        levelMessage = "Obesidad grado II";
    } else if (BMI >= 30) {
        levelMessage = "Obesidad grado I";
    } else if (BMI >= 25) {
        levelMessage = "Sobrepeso";
    } else if (BMI >= 18.5) {
        levelMessage = "Normal";
    } else if (BMI < 18.5) {
        levelMessage = "Bajo peso";
    }
    return levelMessage;
}

export const clientTypeColorClass = (type: string): string => {
    return type === 'PRESENTIAL' ? 'purple lighten-5 purple--text' : 'blue lighten-5 blue--text';
}

export const isAllowed = (permission: string): boolean => {
    const user = store.getters['auth/getUser'];
    if (user.role !== 'ADMIN') return true;
    const userPermissions = store.getters['permissions/getPermissionsList']
    return userPermissions.some((p: any) => p.name === permission);
}

export const printElement = (element: HTMLElement, vuetify: any, quantityTable: QuantityTableInfo, clientInfo: ClientTableInfo): void => {
    const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'));
    const htmlStyles = styles.map((style) => style.outerHTML).join('\n');

    const htmlContent = element.outerHTML;
    const isDark = vuetify.theme.dark;
    const themeClasses = isDark ? 'theme--dark' : 'theme--light';
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    if (!printWindow) return;

    printWindow.document.write(`
        <html>
          <head>
            <title>Tabla de cantidades N${quantityTable.level + quantityTable.tableClass} - ${clientInfo.name}</title>
            ${htmlStyles}
            <style>
              @page {
                  padding: 10px;
                  margin: 10px;
              }
              @media print {
                * {
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                body {
                  background: #fff !important;
                }
              }
            </style>
          </head>
          <body class="${themeClasses}">
            <div data-app="true" class="v-application ${themeClasses}">
              <div class="pa-4"> ${htmlContent}
              </div>
            </div>
          </body>
        </html>
      `);

    printWindow.document.close();
    setTimeout(() => {
        try {
            printWindow.document.body.focus();
            printWindow.print();
            printWindow.close();
        } catch (e) {
            console.error("Error al imprimir:", e);
            printWindow.close();
        }
    }, 1000);
}
